<template>
    <div>
      <div class="loading loadsmall" v-if="loadType === 'small'">
        <img src="./loading.gif" />
        <p class="desc">{{ title }}</p>
      </div>
      <div class="loading loadglobal" id="loading" v-if="loadType === 'global'">
        <div><i></i></div>
      </div>
    </div>
  </template>
  <script>
  export default {
    props: {
      title: {
        type: String,
        default: "正在载入..."
      },
      loadType: {
        type: String,
        default: "global"
      }
    }
  };
  </script>
  <style scoped lang="scss">
  .loadsmall {
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    .desc {
      line-height: 35px;
      font-size: 12px;
      margin-left: 12px;
      color: #939393;
    }
    > img {
      width: 17px;
      height: 17px;
    }
  }
  .loadglobal {
    position: fixed;
    z-index: 10003;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    i {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 30px;
      height: 30px;
      margin-left: -16px;
      -webkit-border-radius: 100px;
      border-radius: 100px;
      border: 2px solid #449bf7;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border-top-color: rgba(51, 51, 51, 0);
      -webkit-animation: my_fhload 0.8s infinite linear;
      animation: my_fhload 0.8s infinite linear;
    }
    > div {
      position: absolute;
      overflow: hidden;
      z-index: 1;
      left: 50%;
      top: 40%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      width: 85px;
      min-height: 85px;
      text-align: center;
      overflow: hidden;
      -webkit-display: -webkit-box;
      -webkit-display: -webkit-flex;
      display: -webkit-box;
      display: flex;
      -webkit-flex-wrap: wrap;
      flex-wrap: wrap;
      -webkit-align-content: center;
      align-content: center;
    }
    > div:after {
      content: "请稍后";
      display: block;
      margin-top: 64px;
      min-width: 100%;
      color: #eee;
      text-align: center;
      white-space: pre-wrap;
      font-size: 10px !important;
      line-height: 1.3;
    }
    @keyframes my_fhload {
      0% {
        transform: rotate(0);
        -webkit-transform: rotate(0);
      }
      100% {
        transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
      }
    }
    @-webkit-keyframes my_fhload {
      0% {
        transform: rotate(0);
        -webkit-transform: rotate(0);
      }
      100% {
        transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
      }
    }
  }
  </style>
  